import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ESTADO_ESTILO = {
    'RESERVA': 'bg-amber-100 text-amber-800',
    'VENDIDO': 'bg-emerald-100 text-emerald-800',
};

function badgeEstado(estado) {
    return ESTADO_ESTILO[estado] || 'bg-gray-100 text-gray-800';
}

export default function MisReservas() {
    const navigate = useNavigate();
    const [ventas, setVentas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchVentas = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                const response = await fetch(`${API_BASE_URL}/api/ventas/mis-reservas?user=${user.user_usuario}`);
                if (!response.ok) {
                    throw new Error('Error al obtener las reservas');
                }
                const data = await response.json();
                setVentas(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchVentas();
    }, []);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl text-gray-600">Cargando reservas...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 p-4 rounded-lg">
                <div className="text-red-700">Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-gray-800">Mis Reservas</h2>
                <button
                    onClick={() => navigate('/')}
                    className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                    Volver a Fracciones
                </button>
            </div>

            {ventas.length === 0 ? (
                <div className="bg-white rounded-lg shadow-md p-6 text-gray-600">
                    Todavía no registraste ninguna reserva.
                </div>
            ) : (
                <>
                    {/* Tarjetas: pantallas chicas (celular) */}
                    <div className="md:hidden space-y-3">
                        {ventas.map(venta => (
                            <div key={venta.id_venta} className="bg-white rounded-lg shadow-md p-4 space-y-2">
                                <div className="flex justify-between items-start">
                                    <span className="text-sm text-gray-500">
                                        {new Date(venta.fecha_venta).toLocaleDateString('es-PY')}
                                    </span>
                                    <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${badgeEstado(venta.estado_venta)}`}>
                                        {venta.estado_venta}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-800 font-medium">
                                    {venta.nombre_fraccion} / M{venta.numero_manzana} / L{venta.numero_lote}
                                </p>
                                <p className="text-sm text-gray-600">
                                    {venta.nombre_razon_social_cliente}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Tabla: pantallas medianas/grandes */}
                    <div className="hidden md:block bg-white rounded-lg shadow-md overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Fecha</th>
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">F/M/L</th>
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Cliente</th>
                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {ventas.map(venta => (
                                    <tr key={venta.id_venta} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                            {new Date(venta.fecha_venta).toLocaleDateString('es-PY')}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                            {venta.nombre_fraccion} / M{venta.numero_manzana} / L{venta.numero_lote}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-700">
                                            {venta.nombre_razon_social_cliente}
                                        </td>
                                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                                            <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${badgeEstado(venta.estado_venta)}`}>
                                                {venta.estado_venta}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
}
